<template>
  <div>
    <slot name="label">
      <label v-if="label" :class="labelClasses">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
    </slot>

    <slot>
      <v-text-field
        v-model="inputVal"
        v-bind="$attrs"
        :class="inputClasses"
        @change="change"
        @keypress="keypress($event)"
        @keydown="keydown($event)"
        @input="input"
        :rules="rules"
        :suffix="suffix"
      ></v-text-field>
    </slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'base-input',
  props: {
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)',
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: undefined,
    },
    label: {
      type: String,
      description: 'Input label (text before input)',
    },
    name: {
      type: String,
      description: 'Input name ',
    },
    helpText: {
      type: String,
      description: 'Input help text (text after input)',
    },

    labelClasses: {
      type: String,
      description: 'Input label css classes',
    },
    inputClasses: {
      type: String,
      description: 'Input css classes',
    },
    value: {
      type: [String, Number],
      description: 'Input value',
    },
    addonRightIcon: {
      type: String,
      description: 'Addon right icon',
    },
    icon: {
      type: String,
      description: ' left icon',
    },
    errors: {
      default: null,
    },
    state: {
      default: null,
    },
    suffix: {
      default: '',
    },
    rules: {
      description: ' input rules',
      default: Array,
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    change(val) {
      this.$emit('change', val);
    },
    input(val) {
      this.$emit('input', val);
    },
    keypress(event) {
      this.$emit('keypress', event);
    },
    keydown(event) {
      this.$emit('keydown', event);
    },
  },
};
</script>
<style></style>
